const common = {
  Loading: "Caricamento in corso",
  signUp: "Registra",
  login: "Login",
  logout: "Esci",
  email: "E-mail",
  emailFormatErrorTips: "Il formato dell'e-mail non è corretto",
  emailDifferentTips: "Inserisci la stessa email in entrambi i campi.",
  emailRegisteredTips: "Questa e-mail è stata registrata, scegline un'altra.",
  password: "Password",
  passwordFormatErrorTips:
    "La password deve essere di 8-50 caratteri e contenere almeno due categorie tra le seguenti: numero, lettera o carattere speciale.",
  passwordDifferentTips: "Si prega di inserire la stessa password in entrambi i campi.",
  verificationCode: "Codice di verifica",
  verificationCodeErrorTips: "Codice di verifica errato",
  confirm: "Conferma",
  cancel: "Annulla",
  submit: "Invia",
  confirmEmail: "Conferma E-mail",
  formEmptyErrorTips: "Non può essere vuoto qui.",
  country: "Paese/Regione",
  birthday: "Compleanno",
  anonymous: "Anonimo",
  name: "Nome",
  nameFormatErrorTips: "Il nome utente deve essere compreso tra 50 caratteri e non contiene caratteri speciali",
  okBtn: "OK",
  serverErrorTips: "Mi dispiace, qualcosa è andato storto, riprova più tardi.",
  updateSuccessTips: "Modificato con successo",
  authorizationExpiredErrorTips: "L'autorizzazione è scaduta, per favore accedi di nuovo.",
  requestFrequentlyErrorTips: "Troppe richieste sono state fatte in un breve periodo di tempo, per favore riprova più tardi.",
  GetCode:'ottenere il codice'
};

export default common;
